/* src/app/pages/ui-kit/components/empty-list-view/empty-list-view.component.scss */
/*# sourceMappingURL=empty-list-view.component.css.map */
